import React from 'react';
import { useAuth } from '../../commons/Auth';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import LogoHeader from '../../commons/LogoHeader';
import { ButtonLogin, H1Login } from '../../styled-components';
import { Card, CardBody, FormGroup } from 'reactstrap';
import './ChooseService.scss';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { useLoading } from '../../commons/Loading';
import { useState } from 'react';
import { Row, Col } from 'reactstrap';
import LogoExtra from '../../images/service-logo-extra.png';
import LogoPanoramica from '../../images/service-logo-panoramica.png';

function ChooseService({ profile = {}, location, match = {} }) {
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const alert = useAlert();
  const [t] = useTranslation('CHOOSE_SERVICE');
  const history = useHistory();
  const { showLoading, hideLoading } = useLoading();

  const [visibile, setVisible] = useState(false);

  useEffect(() => {
    showLoading();

    if (profile.type) {
      if (['SUPPLIER_INS'].includes(profile.type)) {
        window.location.href = process.env.REACT_APP_PANORAMICA_URL;
        return;
      } else if (
        [
          'BUILDING_ADMIN_1',
          'BUILDING_ADMIN_2',
          'BUILDING_ADMIN_3',
          'BUILDING_ADMIN_4',
          'BUILDING_ADMIN_5',
          'ADMIN_COLLAB',
          'AGENCY',
          'COMMERCIAL',
          'ASSOCIATION',
        ].includes(profile.type)
      ) {
        setVisible(true);
        hideLoading();
      } else {
        history.push('/my-profile');
        return;
      }
    }
  }, [profile]);

  return (
    <div className="App">
      <LogoHeader match={match} />

      {visibile && (
        <div className="corpo">
          <section>
            <div className="container">
              <H1Login>{t('CHOOSE_SERVICE')}</H1Login>

              <Card className="u-center-horizontal login-card">
                <CardBody>
                  <Row className="align-items-center">
                    <Col sm="6" md="6" lg="6" xl="6">
                      <div style={{ width: '100%' }}>
                        <ButtonLogin
                          style={{ width: '100%' }}
                          className="u-center-horizontal extra-button"
                          onClick={(event) => {
                            event.stopPropagation();
                            history.push('/my-profile');
                          }}
                        >
                          <div
                            className="cont-logo-menu"
                            style={{ backgroundColor: '#fff' }}
                          >
                            <img
                              src={LogoExtra}
                              alt="Extra Franchising"
                              style={{ width: '100%' }}
                            />
                          </div>
                        </ButtonLogin>
                      </div>
                    </Col>

                    <Col sm="6" md="6" lg="6" xl="6">
                      <div style={{ width: '100%' }}>
                        <ButtonLogin
                          style={{ width: '100%' }}
                          className="u-center-horizontal panoramica-button"
                          onClick={() => {
                            window.location.href =
                              process.env.REACT_APP_PANORAMICA_URL;
                          }}
                        >
                          <div
                            className="cont-logo-menu"
                            style={{ backgroundColor: '#fff' }}
                          >
                            <img
                              src={LogoPanoramica}
                              alt="Extra Franchising"
                              style={{ width: '100%' }}
                            />
                          </div>
                        </ButtonLogin>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          </section>
        </div>
      )}
    </div>
  );
}

export default ChooseService;
